/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { ChatShowPathParams, ChatShowQueryParams, ChatShowResponse } from '../types/ChatShow'

/**
 * GET /chat/:chat
 * @see backend/nexus/modules/AdGeneration/Http/Controllers/ChatController.php ChatController::show
 */
export async function chatShow(
	chat: ChatShowPathParams['chat'],
	params?: ChatShowQueryParams,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<ChatShowResponse>> {
	return axiosInstance.get(`/chat/${chat}`, { params, ...config })
}
